import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { Box, Grid, Stack, Typography, CircularProgress } from "@mui/material";
import people from "../../../images/CongratsPageSideImage.jpg";
import { CheckCircle } from "@phosphor-icons/react";
import { ClientTopBar } from "../../components/Layout/ClientLayout/ClientTopBar";
import "./Congrats.scss";
import ContractApi from "../../../infrastructure/api/pages/contract-api";
const Congrats = () => {
    const [noOfMonths, setNoOfMonths] = useState(0);
    const [loading, setLoading] = useState(false);
    const [contract, setContract] = useState();
    const [responsiblePerson, setResponsiblePerson] = useState();
    const urlParams = new URLSearchParams(window.location.search);
    const contractId = urlParams.get("contractId");
    useEffect(() => {
        if (contractId) {
            setLoading(true);
            ContractApi.getNumberOfMonthsForPreferredMonth(contractId).then((response) => {
                setNoOfMonths(response.data);
                setLoading(false);
            });
            ContractApi.getById(contractId).then((response) => {
                setContract(response.data);
            });
            ContractApi.getResponsiblePersonByContractId(contractId).then((response) => {
                setResponsiblePerson(response.data);
            });
        }
    }, [contractId]);
    const months = noOfMonths > 0 ? noOfMonths : 12;
    const contactName = [responsiblePerson === null || responsiblePerson === void 0 ? void 0 : responsiblePerson.firstName, responsiblePerson === null || responsiblePerson === void 0 ? void 0 : responsiblePerson.lastName]
        .filter(Boolean)
        .join(" ");
    return (_jsx(Box, { className: "congratscontainer", children: _jsx(Grid, { container: true, className: "gridconatiner", children: _jsxs(Grid, { container: true, sx: {
                    alignItems: "stretch",
                    background: "#F9F6FF",
                    paddingLeft: { xs: "12px", sm: "24px", md: "32px", lg: "64px" },
                    paddingRight: { xs: "12px", sm: "24px", md: "32px", lg: "64px" },
                    paddingTop: { xs: "12px", sm: "24px", md: "32px", lg: "48px" },
                    paddingBottom: "2%"
                }, size: 12, children: [_jsx(Grid, { sx: {
                            background: "#FFFFFF",
                            boxShadow: "-8px 0px 35px 0px rgba(0, 0, 0, 0.16)",
                            borderRadius: {
                                xs: "24px 24px 0px 0px",
                                sm: "24px 24px 0px 0px",
                                md: "24px 0px 0px 24px",
                            },
                            padding: { xs: "6% 6%", md: "4% 6%" },
                            display: "flex",
                            alignItems: "center",
                        }, size: {
                            lg: 6,
                            md: 6,
                            sm: 12
                        }, children: _jsxs(Stack, { spacing: 3, sx: {
                                alignItems: "center",
                                width: "100%"
                            }, children: [_jsx(Box, { sx: {
                                        display: "flex",
                                        justifyContent: "center",
                                        width: "100%"
                                    }, children: _jsx(ClientTopBar, {}) }), _jsxs(Stack, { spacing: 1.5, sx: {
                                        alignItems: "center"
                                    }, children: [_jsx(CheckCircle, { size: 48, color: "#2AA241", weight: "fill" }), _jsx(Typography, { variant: "h2", sx: {
                                                textAlign: "center"
                                            }, children: "Bedankt voor jouw vertrouwen in Eurosafe!" }), _jsx(Typography, { variant: "body1", sx: {
                                                textAlign: "center",
                                                color: "text.secondary"
                                            }, children: "Je gegevens zijn compleet en in goede orde ontvangen." }), (contract === null || contract === void 0 ? void 0 : contract.contractNumber) && (_jsxs(Typography, { variant: "body2", sx: {
                                                textAlign: "center",
                                                color: "text.secondary"
                                            }, children: ["Referentienummer: ", contract.contractNumber] }))] }), _jsx(Box, { sx: {
                                        width: "100%",
                                        borderRadius: "12px",
                                        background: "var(--Neutral-100, #F8F9FA)",
                                        padding: "16px 20px",
                                    }, children: _jsxs(Typography, { variant: "body1", sx: {
                                            textAlign: "center"
                                        }, children: ["We plannen de inspectie in binnen nu en", " ", loading ? (_jsx(CircularProgress, { size: 12, color: "inherit" })) : (_jsx(_Fragment, { children: months })), " ", "maanden. Zodra de eerste inspectiedatum bekend is, nemen we contact met je op."] }) }), responsiblePerson && (contactName || responsiblePerson.email) && (_jsxs(Typography, { variant: "body2", sx: {
                                        textAlign: "center",
                                        color: "text.secondary"
                                    }, children: ["Heeft u nog vragen? Neem gerust contact op met ", contactName, responsiblePerson.email ? ` via ${responsiblePerson.email}` : "", responsiblePerson.phoneNumber ? ` of ${responsiblePerson.phoneNumber}` : "", "."] })), _jsxs(Stack, { spacing: 0, sx: {
                                        alignItems: "center"
                                    }, children: [_jsx(Typography, { variant: "body2", children: "Met vriendelijke groeten," }), _jsx(Typography, { variant: "body2", children: "Team Eurosafe" })] })] }) }), _jsx(Grid, { className: "side-image", sx: {
                            background: "#A9D1D9",
                            boxShadow: "-8px 0px 35px 0px rgba(0, 0, 0, 0.16)",
                            borderRadius: {
                                xs: "0px 0px 24px 24px",
                                sm: "0px 0px 24px 24px",
                                md: "0px 24px 24px 0px",
                            },
                        }, size: {
                            lg: 6,
                            md: 6,
                            sm: 12
                        }, children: _jsx(Box, { component: "img", src: people, sx: {
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                display: "block"
                            } }) })] }) }) }));
};
export default Congrats;
